// import React, { useState, useRef, useEffect } from 'react';
// import { apiCall } from '@/api/apiCall';
// import { toast } from 'sonner';
// import { useApiQueue } from '@/hooks/useApiQueue';
// import DammamContract from '@/assets/img/DammamContract.png';
// import CarPark from '@/assets/img/TaifContract-carPark.png';
// import OnStreet from '@/assets/img/TaifContract-onStreet.png';
// import Enforcement from '@/assets/img/TaifContract-Enforcement.png';
// import { AssetsPanel } from '../../components/shared/AssetsPanel';
// import { API_CALL_TIME } from '@/constants/constant';

// // ═══════════════════════════════════════════════════════════════════════
// // HELPERS
// // ═══════════════════════════════════════════════════════════════════════
// const groupsToFlat = (groups = []) => {
//   const result = [];
//   groups.forEach(g => {
//     result.push({ name: g.group_name || '', isCategory: true, subCount: '', totalCount: String(g.group_total_qty ?? '-') });
//     (g.items || []).forEach(item => {
//       result.push({ name: item.item_name || '', isCategory: false, subCount: String(item.qty ?? '-'), totalCount: '' });
//     });
//   });
//   return result;
// };

// const flatToGroups = (flat) => {
//   const groups = [];
//   let cur = null;
//   flat.forEach(a => {
//     if (a.isCategory) {
//       if (cur) groups.push(cur);
//       cur = { group_name: a.name, group_total_qty: a.totalCount || '', items: [] };
//     } else if (cur) {
//       cur.items.push({ item_name: a.name, qty: a.subCount || '' });
//     }
//   });
//   if (cur) groups.push(cur);
//   return groups;
// };

// // ═══════════════════════════════════════════════════════════════════════
// // ASSET GROUPS HELPER
// // ═══════════════════════════════════════════════════════════════════════
// function makeAssetGroups(o = {}) {
//   return [
//     { group_name: 'Ticket Dispenser', group_total_qty: o.ticketDispenser ?? '-', items: [{ item_name: 'DIP G100', qty: o.dipG100 ?? '-' }, { item_name: 'G100 64 Bit', qty: o.g10064 ?? '-' }, { item_name: 'G100 32 Bit', qty: o.g10032 ?? '-' }] },
//     { group_name: 'Ticket Verifier', group_total_qty: o.ticketVerifier ?? '-', items: [{ item_name: 'EV DIP G100', qty: o.evDipG100 ?? '-' }, { item_name: 'EV G100 64 Bit', qty: o.evG10064 ?? '-' }, { item_name: 'EV G100 32 Bit', qty: o.evG10032 ?? '-' }] },
//     { group_name: "APM's", group_total_qty: o.apms ?? '-', items: [{ item_name: 'APM ETS-70', qty: o.apmEts70 ?? '-' }, { item_name: 'APM ETS-100', qty: o.apmEts100 ?? '-' }] },
//     { group_name: 'PIN Pad', group_total_qty: o.pinPad ?? '-', items: [{ item_name: 'IUP250', qty: o.iup250 ?? '-' }] },
//     { group_name: 'Card Reader', group_total_qty: o.cardReader ?? '-', items: [{ item_name: 'IUR250', qty: o.iur250 ?? '-' }] },
//     { group_name: 'B-Contactless', group_total_qty: o.bContactless ?? '-', items: [{ item_name: 'IUC150', qty: o.bContactlessItem ?? '-' }] },
//     { group_name: 'RFID Reader', group_total_qty: o.rfidReader ?? '-', items: [] },
//     { group_name: 'IP Barrier', group_total_qty: o.ipBarrier ?? '-', items: [] },
//     { group_name: 'ANPR CAMERA', group_total_qty: o.anprCamera ?? '-', items: [{ item_name: 'ARH', qty: o.arh ?? '-' }, { item_name: 'Luminera', qty: o.luminera ?? '-' }] },
//     { group_name: 'Sliding Gate', group_total_qty: o.slidingGate ?? '-', items: [{ item_name: 'RIGHT', qty: o.right ?? '-' }, { item_name: 'LEFT', qty: o.left ?? '-' }] },
//     { group_name: "PND's", group_total_qty: o.pnds ?? '-', items: [{ item_name: 'TPAL- BNA Large', qty: o.tpalBna ?? '-' }, { item_name: 'T-PAL TX', qty: o.tpalTx ?? '-' }, { item_name: 'T-PAL V2', qty: o.tpalV2 ?? '-' }] },
//     { group_name: 'Pound Cahier Device', group_total_qty: o.poundCahier ?? '-', items: [{ item_name: 'CN-50', qty: o.cn50 ?? '-' }] },
//     { group_name: 'Driver Device', group_total_qty: o.driverDevice ?? '-', items: [{ item_name: 'CN-51', qty: o.cn51 ?? '-' }] },
//     { group_name: 'Enf Device', group_total_qty: o.enfDevice ?? '-', items: [{ item_name: 'Oukitel WP2', qty: o.oukitel ?? '-' }, { item_name: 'Doogee V10', qty: o.doogee ?? '-' }] },
//     { group_name: 'Validation', group_total_qty: o.validation ?? '-', items: [{ item_name: 'Lenova Tablet', qty: o.lenovaTablet ?? '-' }] },
//     { group_name: 'Printer', group_total_qty: o.printer ?? '-', items: [{ item_name: 'PR-3', qty: o.pr3 ?? '-' }, { item_name: 'SEWOOR', qty: o.sewoo ?? '-' }, { item_name: 'BIXOLON', qty: o.bixolon ?? '-' }] },
//     { group_name: 'Tow Truck', group_total_qty: o.towTruck ?? '-', items: [] },
//     { group_name: 'Clamp Vehicle', group_total_qty: o.clampVehicle ?? '-', items: [] },
//     { group_name: 'Support Vehicle', group_total_qty: o.supportVehicle ?? '-', items: [] },
//   ];
// }

// // ═══════════════════════════════════════════════════════════════════════
// // CONFIG
// // ═══════════════════════════════════════════════════════════════════════
// const DAMMAM_CAUSEWAY_PROFILE_CONFIG = {

//   // ── Dammam Causeway On-Street Profile ──────────────────────────────
//   dammam_causeway_on_street_profile: {
//     profileKey: 'dammam_causeway_on_street_profile',
//     parkingRateKey: 'dammam_causeway_on_street_parking_rate',
//     assetsKey: 'dammam_causeway_on_street_assets',
//     pageType: 'on_street',

//     profileFallback: {
//       table_key: 'dammam_causeway_on_street_profile',
//       title: 'Dammam Causeway On Street - Profile',
//       data: {
//         total_bays: { label: 'Total On-Street Parking Bays', value: '30' },
//         contract_term: { value: '05 years;' },
//         contract_period: { start_date: '01.01.2024', end_date: '31.12.2028' },
//         rate_per_hour: { value: 'SAR 5.00 excluding VAT 15%' },
//         operation_timing: { value: '24 Hours' },
//       },
//     },

//     parkingRateFallback: {
//       table_key: 'dammam_causeway_on_street_parking_rate',
//       title: 'Dammam Causeway On Street Parking Rate',
//       data: {
//         rows: [
//           { details: 'Hourly', parking_rate: 'SAR 5' },
//         ],
//       },
//     },

//     assetsFallback: {
//       table_key: 'dammam_causeway_on_street_assets',
//       title: 'Dammam Causeway On - Street',
//       data: {
//         groups: makeAssetGroups({
//           ticketDispenser: '-', ticketVerifier: '-',
//           apms: '-', pinPad: '-', cardReader: '-',
//           bContactless: '-', rfidReader: '-', ipBarrier: '-',
//           anprCamera: '-', slidingGate: '-',
//           pnds: '3', tpalBna: '-', tpalTx: '-', tpalV2: '3',
//           poundCahier: '-', driverDevice: '-',
//           enfDevice: '2', oukitel: '2', doogee: '-',
//           validation: '-', printer: '1', pr3: '1', sewoo: '-', bixolon: '-',
//           towTruck: '1', clampVehicle: '-', supportVehicle: '-',
//         }),
//       },
//     },
//   },

//   // ── Dammam Causeway Off-Street Profile ─────────────────────────────
//   dammam_causeway_off_street_profile: {
//     profileKey: 'dammam_causeway_off_street_profile',
//     membershipKey: 'dammam_causeway_off_street_membership',
//     casualParkingKey: 'dammam_causeway_off_street_casual_parking',
//     assetsKey: 'dammam_causeway_off_street_assets',
//     pageType: 'off_street',

//     profileFallback: {
//       table_key: 'dammam_causeway_off_street_profile',
//       title: 'Dammam Causeway Off-Street Profile',
//       data: {
//         total_bays: { label: 'Total Off Street Car Park Bays', value: '585' },
//         contract_term: { value: '5 years' },
//         contract_period: { start_date: '01.01.2024', end_date: '31.12.2028' },
//         rate_per_hour: { value: 'SAR 5.00 excluding 15% VAT' },
//         operation_timing: { value: '24 Hours' },
//         membership_tariff: { value: 'Membership Rates excluding VAT 15%' },
//       },
//     },

//     membershipFallback: {
//       table_key: 'dammam_causeway_off_street_membership',
//       title: 'Membership Details',
//       data: {
//         rows: [
//           { membership_details: 'Jawazat', location: 'P-3', charges: 'Free' },
//           { membership_details: 'Customs Brokers', location: 'P-2', charges: 'Free' },
//           { membership_details: 'KFCA Authority vehicles', location: 'P-1', charges: 'Free' },
//           { membership_details: 'SRACO & KMC Maintenance Vehicle', location: 'P-1', charges: 'Free' },
//           { membership_details: 'Commercial companies', location: 'P-1', charges: 'Free' },
//           { membership_details: 'Police & Murror', location: 'P-1', charges: 'Free' },
//           { membership_details: 'Budget Renal Car', location: 'P-1', charges: 'SAR 720/M' },
//           { membership_details: 'Hayakom Rental Cars', location: 'P-1', charges: 'SAR 720/M' },
//           { membership_details: 'Majestic Rental Cars', location: 'P-1', charges: 'SAR 720/M' },
//         ],
//       },
//     },

//     casualParkingFallback: {
//       table_key: 'dammam_causeway_off_street_casual_parking',
//       title: 'Casual Parking',
//       data: {
//         rows: [
//           { details: 'KFCA Parking', parking_rate: 'SAR 5 per hour' },
//           { details: 'Lost Ticket', parking_rate: 'SAR 25' },
//           { details: 'RFID', parking_rate: 'SAR 100' },
//         ],
//       },
//     },

//     assetsFallback: {
//       table_key: 'dammam_causeway_off_street_assets',
//       title: 'Dammam Causeway Off - Street',
//       data: {
//         groups: makeAssetGroups({
//           ticketDispenser: '3', dipG100: '3',
//           ticketVerifier: '3', evDipG100: '3',
//           apms: '4', apmEts70: '2', apmEts100: '2',
//           pinPad: '7', iup250: '7',
//           cardReader: '4', iur250: '4',
//           bContactless: '7', bContactlessItem: '7',
//           rfidReader: '7', ipBarrier: '6', anprCamera: '6', arh: '6',
//           slidingGate: '-',
//           pnds: '-', poundCahier: '-', driverDevice: '-', enfDevice: '-',
//           validation: '-', printer: '-', towTruck: '-', clampVehicle: '-', supportVehicle: '-',
//         }),
//       },
//     },
//   },
// };


// // ═══════════════════════════════════════════════════════════════════════
// // MAIN COMPONENT
// // ═══════════════════════════════════════════════════════════════════════
// const DammamCausewayProfile = ({ page, year = '', monthNumber = '', contract = '' }) => {
//   const cfg = DAMMAM_CAUSEWAY_PROFILE_CONFIG[page?.type];
//   if (!cfg) return null;

//   const hasFetchedRef = useRef(false);
//   const saveRef = useRef(null);
//   const [isSaving, setIsSaving] = useState(false);
//   const [profileTable, setProfileTable] = useState(cfg.profileFallback);
//   const [assetsTable, setAssetsTable] = useState(cfg.assetsFallback);
//   const [parkingRateTable, setParkingRateTable] = useState(cfg.parkingRateFallback || null);
//   const [membershipTable, setMembershipTable] = useState(cfg.membershipFallback || null);
//   const [casualParkingTable, setCasualParkingTable] = useState(cfg.casualParkingFallback || null);
//   const { enqueue } = useApiQueue();

//   // ── Refs for latest state (Stale State Fix) ─────────────────────────────
//   const profileRef        = useRef(null);
//   const assetsRef         = useRef(null);
//   const parkingRateRef    = useRef(null);
//   const membershipRef     = useRef(null);
//   const casualParkingRef  = useRef(null);

//   // Sync refs with latest state
//   useEffect(() => { profileRef.current       = profileTable;      }, [profileTable]);
//   useEffect(() => { assetsRef.current        = assetsTable;       }, [assetsTable]);
//   useEffect(() => { parkingRateRef.current   = parkingRateTable;  }, [parkingRateTable]);
//   useEffect(() => { membershipRef.current    = membershipTable;   }, [membershipTable]);
//   useEffect(() => { casualParkingRef.current = casualParkingTable;}, [casualParkingTable]);

//   // ── Fetch ──────────────────────────────────────────────────────────
//   useEffect(() => {
//     if (hasFetchedRef.current) return;
//     hasFetchedRef.current = true;
//     fetchData();
//   }, [year, monthNumber, contract]);

//   const fetchData = async () => {
//     try {
//       const res = await enqueue(() => apiCall('GET', '/boardpack/get-tables-data', { year, contract, month: monthNumber }));
//       if (!res?.success) return;
//       const data = res?.data || [];
//       const find = (key, fb) => data.find(t => t.table_key === key) || fb;

//       setProfileTable(find(cfg.profileKey, cfg.profileFallback));
//       setAssetsTable(find(cfg.assetsKey, cfg.assetsFallback));
//       if (cfg.parkingRateKey) setParkingRateTable(find(cfg.parkingRateKey, cfg.parkingRateFallback));
//       if (cfg.membershipKey) setMembershipTable(find(cfg.membershipKey, cfg.membershipFallback));
//       if (cfg.casualParkingKey) setCasualParkingTable(find(cfg.casualParkingKey, cfg.casualParkingFallback));
//     } catch (err) {
//       console.error('Fetch error:', err);
//     }
//   };

//   // ── Auto-save ──────────────────────────────────────────────────────
//   const autoSave = () => {
//     if (saveRef.current) clearTimeout(saveRef.current);
//     saveRef.current = setTimeout(saveToAPI, API_CALL_TIME);
//   };

//    // ── Fixed saveToAPI using Refs ────────────────────────────────────────────
//   const saveToAPI = async () => {
//     try {
//       setIsSaving(true);

//       const tables = [
//         { 
//           table_key: profileRef.current?.table_key, 
//           title: profileRef.current?.title, 
//           data: profileRef.current?.data 
//         },
//         { 
//           table_key: assetsRef.current?.table_key, 
//           title: assetsRef.current?.title, 
//           data: assetsRef.current?.data 
//         },
//       ];

//       if (parkingRateRef.current) {
//         tables.push({ 
//           table_key: parkingRateRef.current.table_key, 
//           title: parkingRateRef.current.title, 
//           data: parkingRateRef.current.data 
//         });
//       }
//       if (membershipRef.current) {
//         tables.push({ 
//           table_key: membershipRef.current.table_key, 
//           title: membershipRef.current.title, 
//           data: membershipRef.current.data 
//         });
//       }
//       if (casualParkingRef.current) {
//         tables.push({ 
//           table_key: casualParkingRef.current.table_key, 
//           title: casualParkingRef.current.title, 
//           data: casualParkingRef.current.data 
//         });
//       }

//       const res = await apiCall('POST', '/boardpack/add-tables-data', {
//         contract, 
//         year, 
//         month: monthNumber, 
//         created_by: 1, 
//         tables,
//       });

//       if (!res?.success) throw new Error(res?.message || 'Save failed');
//     } catch (err) {
//       console.error('Save error:', err);
//       toast.error('Failed to save changes');
//     } finally {
//       setIsSaving(false);
//     }
//   };
//   // ── Patch helpers ──────────────────────────────────────────────────
//   const patchProfile = (field, subField, value) => {
//     setProfileTable(prev => ({
//       ...prev,
//       data: { ...prev.data, [field]: subField ? { ...prev.data[field], [subField]: value } : value },
//     }));
//     autoSave();
//   };

//   const handleParkingRateCell = (rIdx, key, value) => {
//     setParkingRateTable(prev => ({
//       ...prev,
//       data: { ...prev.data, rows: prev.data.rows.map((r, i) => i === rIdx ? { ...r, [key]: value } : r) },
//     }));
//     autoSave();
//   };

//   const handleMembershipCell = (rIdx, key, value) => {
//     setMembershipTable(prev => ({
//       ...prev,
//       data: { ...prev.data, rows: prev.data.rows.map((r, i) => i === rIdx ? { ...r, [key]: value } : r) },
//     }));
//     autoSave();
//   };

//   const handleCasualParkingCell = (rIdx, key, value) => {
//     setCasualParkingTable(prev => ({
//       ...prev,
//       data: { ...prev.data, rows: prev.data.rows.map((r, i) => i === rIdx ? { ...r, [key]: value } : r) },
//     }));
//     autoSave();
//   };

//   const handleAssetSubCount = (flatIdx, value) => {
//     const flat = groupsToFlat(assetsTable.data.groups).map((a, i) => i === flatIdx ? { ...a, subCount: value } : a);
//     setAssetsTable(prev => ({ ...prev, data: { ...prev.data, groups: flatToGroups(flat) } }));
//     autoSave();
//   };

//   const handleAssetTotalCount = (flatIdx, value) => {
//     const flat = groupsToFlat(assetsTable.data.groups).map((a, i) => i === flatIdx ? { ...a, totalCount: value } : a);
//     setAssetsTable(prev => ({ ...prev, data: { ...prev.data, groups: flatToGroups(flat) } }));
//     autoSave();
//   };

//   // ── Derived ────────────────────────────────────────────────────────
//   const pd = profileTable.data;
//   const flatAssets = groupsToFlat(assetsTable.data.groups);
//   const pageType = cfg.pageType;

//   // ═══════════════════════════════════════════════════════════════════
//   // RENDER
//   // ═══════════════════════════════════════════════════════════════════
//   return (
//     <div className="min-h-screen p-4 md:p-6 lg:p-8 bg-white">

//       {/* ── Header ── */}
//       <div className="flex justify-between items-center mb-3">
//         <div className="ml-2">
//           <img src={DammamContract} alt="Dammam Causeway Logo" style={{ height: '50px', objectFit: 'contain' }} />
//         </div>
//         <h1 className="text-xl font-bold flex-1 text-center">{profileTable.title}</h1>
//         <div className="w-10 h-10 bg-[#003d7a] flex-shrink-0" />
//       </div>

//       {/* ══════════════════════════════════════
//           ON-STREET PAGE
//       ══════════════════════════════════════ */}
//       {pageType === 'on_street' && (
//         <div className="flex flex-col lg:flex-row gap-0 !border-2 !border-black p-3">

//           {/* ── LEFT ── */}
//           <div className="flex-1 pr-4">

//             {/* Activities icons row */}
//             <div className="mb-4">
//               <div className="text-[16px] font-semibold mb-4">Activities:</div>
//               <div className="flex gap-0 justify-start ml-16 ">
//                 {['On Street', 'Car Park', 'Enforcement'].map(label => (
//                   <div key={label} className="flex flex-col items-center gap-2 ">
//                     {label === 'On Street' && <img src={OnStreet} alt="Bab Al Ree Logo" style={{ height: '150px', objectFit: 'contain' }} />}
//                     {label === 'Car Park' && <img src={CarPark} alt="Bab Al Ree Logo" style={{ height: '155px', objectFit: 'contain' }} />}
//                     {label === 'Enforcement' && <img src={Enforcement} alt="Bab Al Ree Logo" style={{ height: '150px', objectFit: 'contain' }} />}
//                   </div>


//                 ))}
//               </div>
//             </div>

//             {/* Profile info */}
//             <div className="flex flex-col gap-1 mb-4">

//               {/* Total Bays */}
//               <div className="flex items-center gap-2 ml-2 ">
//                 <div className="w-10 h-8   rounded flex items-center justify-center text-[8px] text-gray-400 mb-4">
//                   <img src={OnStreet} alt="On Street" style={{ height: '50px', objectFit: 'contain' }} />
//                 </div>
//                 <span className="text-[12px]">
//                   {pd.total_bays?.label}{' '}
//                   <strong>
//                     <input type="text" value={pd.total_bays?.value || ''}
//                       onChange={e => patchProfile('total_bays', 'value', e.target.value)}
//                       className="font-bold outline-none bg-transparent !border-0 text-[12px] w-16" />
//                   </strong>
//                 </span>
//               </div>

//               {/* Contract term */}
//               <div className="flex items-center gap-2 ml-14">
//                 <div className="w-2 h-2 !border !border-blue-600 flex-shrink-0" />
//                 <span className="text-[12px] flex items-center gap-1 whitespace-nowrap">
//                   Contract term{' '}
//                   <strong><input type="text" value={pd.contract_term?.value || ''}
//                     onChange={e => patchProfile('contract_term', 'value', e.target.value)}
//                     className="font-bold outline-none bg-transparent !border-0 text-[12px] w-13" /></strong>; start date{' '}
//                   <strong><input
//                     type="text"
//                     value={pd.contract_period?.start_date || ''}
//                     onChange={e => patchProfile('contract_period', 'start_date', e.target.value)}
//                     className="font-bold outline-none bg-transparent !border-0 text-[12px] w-17"
//                   />
//                     {' to '}
//                     <input
//                       type="text"
//                       value={pd.contract_period?.end_date || ''}
//                       onChange={e => patchProfile('contract_period', 'end_date', e.target.value)}
//                       className="font-bold outline-none bg-transparent !border-0 text-[12px] w-20"
//                     /></strong>
//                 </span>
//                 {/* <span className="text-[12px] flex items-center gap-1 whitespace-nowrap">
//                   Contract term{' '}
//                   <strong><input type="text" value={pd.contract_term?.value || ''}
//                     onChange={e => patchProfile('contract_term', 'value', e.target.value)}
//                     className="font-bold outline-none bg-transparent !border-0 text-[12px] w-14" /></strong>; start date{' '}
//                   <strong><input type="text" value={pd.contract_period?.start_date || ''}
//                     onChange={e => patchProfile('contract_period', 'start_date', e.target.value)}
//                     className="font-bold outline-none bg-transparent !border-0 text-[12px] w-18" /></strong>
//                   {' to '}
//                   <strong><input type="text" value={pd.contract_period?.end_date || ''}
//                     onChange={e => patchProfile('contract_period', 'end_date', e.target.value)}
//                     className="font-bold outline-none bg-transparent !border-0 text-[12px] " /></strong>
//                 </span> */}
//               </div>

//               {/* Rate per Hour */}
//               <div className="flex items-center gap-2 ml-14">
//                 <div className="w-2 h-2 !border !border-blue-600 flex-shrink-0" />
//                 <span className="text-[12px] flex items-center gap-1">
//                   Rate per Hour{' '}
//                   <strong><input type="text" value={pd.rate_per_hour?.value || ''}
//                     onChange={e => patchProfile('rate_per_hour', 'value', e.target.value)}
//                     className="font-bold outline-none bg-transparent !border-0 text-[12px] w-52" /></strong>
//                 </span>
//               </div>

//               {/* Operation Timing */}
//               <div className="flex items-center gap-2 ml-14">
//                 <div className="w-2 h-2 !border !border-blue-600 flex-shrink-0" />
//                 <span className="text-[12px] flex items-center gap-1">
//                   Operation Timing –{' '}
//                   <strong><input type="text" value={pd.operation_timing?.value || ''}
//                     onChange={e => patchProfile('operation_timing', 'value', e.target.value)}
//                     className="font-bold outline-none bg-transparent !border-0 text-[12px] w-24" /></strong>
//                 </span>
//               </div>

//               {/* Assets Deployed */}
//               <div className="flex items-center gap-2 ml-14">
//                 <div className="w-3 h-3 rounded-full bg-red-500 flex-shrink-0" />
//                 <span className="text-[12px]">Assets Deployed</span>
//               </div>
//             </div>

//             {/* Parking Rate Table */}
//             {parkingRateTable && (
//               <div className=" ml-14">
//                 <table className="!border-collapse text-[9px]">
//                   <thead>
//                     <tr className="bg-gray-300">
//                       <th className="!border !border-black px-4 py-2 font-bold text-center" style={{ minWidth: '200px' }}>
//                         Dammam Causeway On Street
//                       </th>
//                       <th className="!border !border-black px-4 py-2 font-bold text-center" style={{ minWidth: '120px' }}>
//                         Parking Rate
//                       </th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {parkingRateTable.data.rows.map((row, rIdx) => (
//                       <tr key={rIdx} className={rIdx % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
//                         <td className="!border !border-black px-3 py-1.5">
//                           <input type="text" value={row.details || ''} onChange={e => handleParkingRateCell(rIdx, 'details', e.target.value)}
//                             className="!border-0 bg-transparent outline-none text-[9px] w-full" />
//                         </td>
//                         <td className="!border !border-black px-3 py-1.5 text-center">
//                           <input type="text" value={row.parking_rate || ''} onChange={e => handleParkingRateCell(rIdx, 'parking_rate', e.target.value)}
//                             className="!border-0 bg-transparent outline-none text-[9px] text-end w-full" />
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             )}
//           </div>

//           {/* ── RIGHT — Assets ── */}
//           <AssetsPanel
//             assetsTable={assetsTable}
//             flatAssets={flatAssets}
//             onSubCount={handleAssetSubCount}
//             onTotalCount={handleAssetTotalCount}
//           />
//         </div>
//       )}

//       {/* ══════════════════════════════════════
//           OFF-STREET PAGE
//       ══════════════════════════════════════ */}
//       {pageType === 'off_street' && (
//         <div className="flex flex-col lg:flex-row gap-0 !border-2 !border-black p-3  ">

//           {/* ── LEFT ── */}
//           <div className="flex-1 pr-4">

//             {/* Car Park icon + info */}
//             <div className="flex items-start gap-3 mb-4">
//               <div className="flex flex-col items-center  w-20 flex-shrink-0 mb-4">
//                 <img src={CarPark} alt="Car Park" style={{ height: '50px', objectFit: 'contain' }} />
//                 {/* <div className="w-16 h-12 bg-gray-100 flex items-center justify-center text-[9px] text-gray-500">Car Park</div> */}
//               </div>

//               <div className="flex flex-col gap-1  ">

//                 {/* Total Bays */}
//                 <div className="flex items-center gap-2  ">
//                   <span className="text-[12px] ">
//                     {pd.total_bays?.label}{' '}
//                     <strong>
//                       <input type="text" value={pd.total_bays?.value || ''}
//                         onChange={e => patchProfile('total_bays', 'value', e.target.value)}
//                         className="font-bold outline-none bg-transparent !border-0 text-[12px] w-16 " />
//                     </strong>
//                   </span>
//                 </div>

//                 {/* Contract term */}
//                 <div className="flex items-center gap-2 ml-4">
//                   <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//                   <span className="text-[12px] flex items-center flex-wrap gap-1">
//                     Contract term{' '}
//                     <strong><input type="text" value={pd.contract_term?.value || ''}
//                       onChange={e => patchProfile('contract_term', 'value', e.target.value)}
//                       className="font-bold outline-none bg-transparent !border-0 text-[12px] w-11" /></strong>
//                     ; start date{' '}
//                     <strong><input type="text" value={pd.contract_period?.start_date || ''}
//                       onChange={e => patchProfile('contract_period', 'start_date', e.target.value)}
//                       className="font-bold outline-none bg-transparent !border-0 text-[12px] w-17" /></strong>
//                     {' to '}
//                     <strong><input type="text" value={pd.contract_period?.end_date || ''}
//                       onChange={e => patchProfile('contract_period', 'end_date', e.target.value)}
//                       className="font-bold outline-none bg-transparent !border-0 text-[12px] w-16" /></strong>
//                   </span>
//                 </div>

//                 {/* Rate per Hour */}
//                 <div className="flex items-center gap-2 ml-4">
//                   <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//                   <span className="text-[12px] flex items-center gap-1">
//                     Rate per Hour{' '}
//                     <strong><input type="text" value={pd.rate_per_hour?.value || ''}
//                       onChange={e => patchProfile('rate_per_hour', 'value', e.target.value)}
//                       className="font-bold outline-none bg-transparent !border-0 text-[12px] w-52" /></strong>
//                   </span>
//                 </div>

//                 {/* Operation Timing */}
//                 <div className="flex items-center gap-2 ml-4">
//                   <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//                   <span className="text-[12px] flex items-center gap-1">
//                     Operation Timing –{' '}
//                     <strong><input type="text" value={pd.operation_timing?.value || ''}
//                       onChange={e => patchProfile('operation_timing', 'value', e.target.value)}
//                       className="font-bold outline-none bg-transparent !border-0 text-[12px] w-24" /></strong>
//                   </span>
//                 </div>

//                 {/* Assets Deployed */}
//                 <div className="flex items-center gap-2 ml-4">
//                   <div className="w-3 h-3 rounded-full bg-red-500 flex-shrink-0" />
//                   <span className="text-[12px]">Assets Deployed</span>
//                 </div>

//                 {/* Membership Rates note */}
//                 <div className="flex items-center gap-2 ml-4">
//                   <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />

//                   <span className="text-[12px] whitespace-nowrap">
//                     {(() => {
//                       const fullText = pd.membership_tariff?.value || ''

//                       // split first 2 words (Membership Tariff)
//                       const parts = fullText.split(' ')
//                       const label = parts.slice(0, 2).join(' ')
//                       const remaining = parts.slice(2).join(' ')

//                       return (
//                         <>
//                           <span className="font-normal">{label} </span>

//                           <input
//                             type="text"
//                             value={remaining}
//                             onChange={e =>
//                               patchProfile(
//                                 'membership_tariff',
//                                 'value',
//                                 label + ' ' + e.target.value
//                               )
//                             }
//                             className="outline-none bg-transparent border-0 text-[12px] font-bold w-48 inline"
//                           />
//                         </>
//                       )
//                     })()}
//                   </span>
//                 </div>
//               </div>
//             </div>

//             {/* Tables row */}
//             <div className="flex flex-col xl:flex-row gap-4 ml-4">

//               {/* Membership Details Table */}
//               <div className="flex flex-col gap-2 w-fit">

//                 {/* Membership Table */}
//                 {membershipTable && (
//                   <table className=" !border border-black border-collapse text-[9px] border-2 border-black">
//                     <thead>
//                       <tr className="bg-gray-300">
//                         <th className="!border border-black px-2 py-1 text-center min-w-[200px]">
//                           {membershipTable.title}
//                         </th>
//                         <th className="!border border-black px-2 py-1 text-center min-w-[70px]">
//                           Location
//                         </th>
//                         <th className="!border border-black px-2 py-1 text-center min-w-[80px]">
//                           Charges
//                         </th>
//                       </tr>
//                     </thead>

//                     <tbody>
//                       {membershipTable.data.rows.map((row, rIdx) => (
//                         <tr key={rIdx}>
//                           <td className="!border border-black px-1 py-1">
//                             <input
//                               value={row.membership_details || ''}
//                               onChange={e =>
//                                 handleMembershipCell(rIdx, 'membership_details', e.target.value)
//                               }
//                               className="w-full bg-transparent outline-none text-[9px]"
//                             />
//                           </td>

//                           <td className="!border border-black px-1 py-1 text-center">
//                             <input
//                               value={row.location || ''}
//                               onChange={e =>
//                                 handleMembershipCell(rIdx, 'location', e.target.value)
//                               }
//                               className="w-full bg-transparent outline-none text-center text-[9px]"
//                             />
//                           </td>

//                           <td className="!border border-black px-1 py-1 text-center">
//                             <input
//                               value={row.charges || ''}
//                               onChange={e =>
//                                 handleMembershipCell(rIdx, 'charges', e.target.value)
//                               }
//                               className="w-full bg-transparent outline-none text-center text-[9px]"
//                             />
//                           </td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 )}

//                 {/* Casual Parking Table */}
//                 {casualParkingTable && (
//                   <table className=" !border border-black border-collapse text-[9px] border-2 border-black">
//                     <thead>
//                       <tr className="bg-gray-300">
//                         <th className="!border border-black px-2 py-1 text-center min-w-[120px]">
//                           {casualParkingTable.title}
//                         </th>
//                         <th className="border border-black px-2 py-1 text-center min-w-[110px]">
//                           Parking Rate
//                         </th>
//                       </tr>
//                     </thead>

//                     <tbody>
//                       {casualParkingTable.data.rows.map((row, rIdx) => (
//                         <tr key={rIdx}>
//                           <td className="!border border-black px-1 py-1">
//                             <input
//                               value={row.details || ''}
//                               onChange={e =>
//                                 handleCasualParkingCell(rIdx, 'details', e.target.value)
//                               }
//                               className="w-full bg-transparent outline-none text-[9px]"
//                             />
//                           </td>

//                           <td className="!border border-black px-1 py-1 text-center">
//                             <input
//                               value={row.parking_rate || ''}
//                               onChange={e =>
//                                 handleCasualParkingCell(rIdx, 'parking_rate', e.target.value)
//                               }
//                               className="w-full bg-transparent outline-none text-center text-[9px]"
//                             />
//                           </td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 )}

//               </div>
//             </div>
//           </div>

//           {/* ── RIGHT — Assets ── */}
//           <AssetsPanel
//             assetsTable={assetsTable}
//             flatAssets={flatAssets}
//             onSubCount={handleAssetSubCount}
//             onTotalCount={handleAssetTotalCount}
//           />
//         </div>
//       )}

//       {/* {isSaving && (
//         <div className="fixed bottom-4 right-4 bg-blue-600 text-white text-xs px-3 py-1.5 rounded shadow-lg z-50">
//           Saving...
//         </div>
//       )} */}
//     </div>
//   );
// };

// export default DammamCausewayProfile;









import React, { useState, useRef, useEffect } from 'react';
import { apiCall } from '@/api/apiCall';
import { toast } from 'sonner';
import { useApiQueue } from '@/hooks/useApiQueue';
import DammamContract from '@/assets/img/DammamContract.png';
import CarPark from '@/assets/img/TaifContract-carPark.png';
import OnStreet from '@/assets/img/TaifContract-onStreet.png';
import Enforcement from '@/assets/img/TaifContract-Enforcement.png';
import { AssetsPanel } from '../../components/shared/AssetsPanel';
import { API_CALL_TIME } from '@/constants/constant';

// ═══════════════════════════════════════════════════════════════════════
// HELPERS
// ═══════════════════════════════════════════════════════════════════════
const groupsToFlat = (groups = []) => {
  const result = [];
  groups.forEach(g => {
    result.push({ name: g.group_name || '', isCategory: true, subCount: '', totalCount: String(g.group_total_qty ?? '-') });
    (g.items || []).forEach(item => {
      result.push({ name: item.item_name || '', isCategory: false, subCount: String(item.qty ?? '-'), totalCount: '' });
    });
  });
  return result;
};

const flatToGroups = (flat) => {
  const groups = [];
  let cur = null;
  flat.forEach(a => {
    if (a.isCategory) {
      if (cur) groups.push(cur);
      cur = { group_name: a.name, group_total_qty: a.totalCount || '', items: [] };
    } else if (cur) {
      cur.items.push({ item_name: a.name, qty: a.subCount || '' });
    }
  });
  if (cur) groups.push(cur);
  return groups;
};

// ═══════════════════════════════════════════════════════════════════════
// ASSET GROUPS HELPER
// ═══════════════════════════════════════════════════════════════════════
function makeAssetGroups(o = {}) {
  return [
    { group_name: 'Ticket Dispenser', group_total_qty: o.ticketDispenser ?? '-', items: [{ item_name: 'DIP G100', qty: o.dipG100 ?? '-' }, { item_name: 'G100 64 Bit', qty: o.g10064 ?? '-' }, { item_name: 'G100 32 Bit', qty: o.g10032 ?? '-' }] },
    { group_name: 'Ticket Verifier', group_total_qty: o.ticketVerifier ?? '-', items: [{ item_name: 'EV DIP G100', qty: o.evDipG100 ?? '-' }, { item_name: 'EV G100 64 Bit', qty: o.evG10064 ?? '-' }, { item_name: 'EV G100 32 Bit', qty: o.evG10032 ?? '-' }] },
    { group_name: "APM's", group_total_qty: o.apms ?? '-', items: [{ item_name: 'APM ETS-70', qty: o.apmEts70 ?? '-' }, { item_name: 'APM ETS-100', qty: o.apmEts100 ?? '-' }] },
    { group_name: 'PIN Pad', group_total_qty: o.pinPad ?? '-', items: [{ item_name: 'IUP250', qty: o.iup250 ?? '-' }] },
    { group_name: 'Card Reader', group_total_qty: o.cardReader ?? '-', items: [{ item_name: 'IUR250', qty: o.iur250 ?? '-' }] },
    { group_name: 'B-Contactless', group_total_qty: o.bContactless ?? '-', items: [{ item_name: 'IUC150', qty: o.bContactlessItem ?? '-' }] },
    { group_name: 'RFID Reader', group_total_qty: o.rfidReader ?? '-', items: [] },
    { group_name: 'IP Barrier', group_total_qty: o.ipBarrier ?? '-', items: [] },
    { group_name: 'ANPR CAMERA', group_total_qty: o.anprCamera ?? '-', items: [{ item_name: 'ARH', qty: o.arh ?? '-' }, { item_name: 'Luminera', qty: o.luminera ?? '-' }] },
    { group_name: 'Sliding Gate', group_total_qty: o.slidingGate ?? '-', items: [{ item_name: 'RIGHT', qty: o.right ?? '-' }, { item_name: 'LEFT', qty: o.left ?? '-' }] },
    { group_name: "PND's", group_total_qty: o.pnds ?? '-', items: [{ item_name: 'TPAL- BNA Large', qty: o.tpalBna ?? '-' }, { item_name: 'T-PAL TX', qty: o.tpalTx ?? '-' }, { item_name: 'T-PAL V2', qty: o.tpalV2 ?? '-' }] },
    { group_name: 'Pound Cahier Device', group_total_qty: o.poundCahier ?? '-', items: [{ item_name: 'CN-50', qty: o.cn50 ?? '-' }] },
    { group_name: 'Driver Device', group_total_qty: o.driverDevice ?? '-', items: [{ item_name: 'CN-51', qty: o.cn51 ?? '-' }] },
    { group_name: 'Enf Device', group_total_qty: o.enfDevice ?? '-', items: [{ item_name: 'Oukitel WP2', qty: o.oukitel ?? '-' }, { item_name: 'Doogee V10', qty: o.doogee ?? '-' }] },
    { group_name: 'Validation', group_total_qty: o.validation ?? '-', items: [{ item_name: 'Lenova Tablet', qty: o.lenovaTablet ?? '-' }] },
    { group_name: 'Printer', group_total_qty: o.printer ?? '-', items: [{ item_name: 'PR-3', qty: o.pr3 ?? '-' }, { item_name: 'SEWOOR', qty: o.sewoo ?? '-' }, { item_name: 'BIXOLON', qty: o.bixolon ?? '-' }] },
    { group_name: 'Tow Truck', group_total_qty: o.towTruck ?? '-', items: [] },
    { group_name: 'Clamp Vehicle', group_total_qty: o.clampVehicle ?? '-', items: [] },
    { group_name: 'Support Vehicle', group_total_qty: o.supportVehicle ?? '-', items: [] },
  ];
}

// ═══════════════════════════════════════════════════════════════════════
// CONFIG
// ═══════════════════════════════════════════════════════════════════════
const DAMMAM_CAUSEWAY_PROFILE_CONFIG = {

  // ── Dammam Causeway On-Street Profile ──────────────────────────────
  dammam_causeway_on_street_profile: {
    profileKey: 'dammam_causeway_on_street_profile',
    parkingRateKey: 'dammam_causeway_on_street_parking_rate',
    assetsKey: 'dammam_causeway_on_street_assets',
    pageType: 'on_street',

    profileFallback: {
      table_key: 'dammam_causeway_on_street_profile',
      title: 'Dammam Causeway On Street - Profile',
      data: {
        total_bays: { label: 'Total On-Street Parking Bays', value: '30' },
        contract_term: { value: '05 years;' },
        contract_period: { start_date: '01.01.2024', end_date: '31.12.2028' },
        rate_per_hour: { value: 'SAR 5.00 excluding VAT 15%' },
        operation_timing: { value: '24 Hours' },
      },
    },

    parkingRateFallback: {
      table_key: 'dammam_causeway_on_street_parking_rate',
      title: 'Dammam Causeway On Street Parking Rate',
      data: {
        rows: [
          { details: 'Hourly', parking_rate: 'SAR 5' },
        ],
      },
    },

    assetsFallback: {
      table_key: 'dammam_causeway_on_street_assets',
      title: 'Dammam Causeway On - Street',
      data: {
        groups: makeAssetGroups({
          ticketDispenser: '-', ticketVerifier: '-',
          apms: '-', pinPad: '-', cardReader: '-',
          bContactless: '-', rfidReader: '-', ipBarrier: '-',
          anprCamera: '-', slidingGate: '-',
          pnds: '3', tpalBna: '-', tpalTx: '-', tpalV2: '3',
          poundCahier: '-', driverDevice: '-',
          enfDevice: '2', oukitel: '2', doogee: '-',
          validation: '-', printer: '1', pr3: '1', sewoo: '-', bixolon: '-',
          towTruck: '1', clampVehicle: '-', supportVehicle: '-',
        }),
      },
    },
  },

  // ── Dammam Causeway Off-Street Profile ─────────────────────────────
  dammam_causeway_off_street_profile: {
    profileKey: 'dammam_causeway_off_street_profile',
    membershipKey: 'dammam_causeway_off_street_membership',
    casualParkingKey: 'dammam_causeway_off_street_casual_parking',
    assetsKey: 'dammam_causeway_off_street_assets',
    pageType: 'off_street',

    profileFallback: {
      table_key: 'dammam_causeway_off_street_profile',
      title: 'Dammam Causeway Off-Street Profile',
      data: {
        total_bays: { label: 'Total Off Street Car Park Bays', value: '585' },
        contract_term: { value: '5 years' },
        contract_period: { start_date: '01.01.2024', end_date: '31.12.2028' },
        rate_per_hour: { value: 'SAR 5.00 excluding 15% VAT' },
        operation_timing: { value: '24 Hours' },
        membership_tariff: { value: 'Membership Rates excluding VAT 15%' },
      },
    },

    membershipFallback: {
      table_key: 'dammam_causeway_off_street_membership',
      title: 'Membership Details',
      data: {
        rows: [
          { membership_details: 'Jawazat', location: 'P-3', charges: 'Free' },
          { membership_details: 'Customs Brokers', location: 'P-2', charges: 'Free' },
          { membership_details: 'KFCA Authority vehicles', location: 'P-1', charges: 'Free' },
          { membership_details: 'SRACO & KMC Maintenance Vehicle', location: 'P-1', charges: 'Free' },
          { membership_details: 'Commercial companies', location: 'P-1', charges: 'Free' },
          { membership_details: 'Police & Murror', location: 'P-1', charges: 'Free' },
          { membership_details: 'Budget Renal Car', location: 'P-1', charges: 'SAR 720/M' },
          { membership_details: 'Hayakom Rental Cars', location: 'P-1', charges: 'SAR 720/M' },
          { membership_details: 'Majestic Rental Cars', location: 'P-1', charges: 'SAR 720/M' },
        ],
      },
    },

    casualParkingFallback: {
      table_key: 'dammam_causeway_off_street_casual_parking',
      title: 'Casual Parking',
      data: {
        rows: [
          { details: 'KFCA Parking', parking_rate: 'SAR 5 per hour' },
          { details: 'Lost Ticket', parking_rate: 'SAR 25' },
          { details: 'RFID', parking_rate: 'SAR 100' },
        ],
      },
    },

    assetsFallback: {
      table_key: 'dammam_causeway_off_street_assets',
      title: 'Dammam Causeway Off - Street',
      data: {
        groups: makeAssetGroups({
          ticketDispenser: '3', dipG100: '3',
          ticketVerifier: '3', evDipG100: '3',
          apms: '4', apmEts70: '2', apmEts100: '2',
          pinPad: '7', iup250: '7',
          cardReader: '4', iur250: '4',
          bContactless: '7', bContactlessItem: '7',
          rfidReader: '7', ipBarrier: '6', anprCamera: '6', arh: '6',
          slidingGate: '-',
          pnds: '-', poundCahier: '-', driverDevice: '-', enfDevice: '-',
          validation: '-', printer: '-', towTruck: '-', clampVehicle: '-', supportVehicle: '-',
        }),
      },
    },
  },
};


// ═══════════════════════════════════════════════════════════════════════
// MAIN COMPONENT
// ═══════════════════════════════════════════════════════════════════════
const DammamCausewayProfile = ({ page, year = '', month = '', monthNumber = '', contract = '' }) => {
  const cfg = DAMMAM_CAUSEWAY_PROFILE_CONFIG[page?.type];
  if (!cfg) return null;

  const hasFetchedRef = useRef(false);
  const saveRef = useRef(null);
  const [isSaving, setIsSaving] = useState(false);
  
  // 🔥 State for second API (parking bays)
  const [parkingBaysData, setParkingBaysData] = useState(null);
  
  const [profileTable, setProfileTable] = useState(cfg.profileFallback);
  const [assetsTable, setAssetsTable] = useState(cfg.assetsFallback);
  const [parkingRateTable, setParkingRateTable] = useState(cfg.parkingRateFallback || null);
  const [membershipTable, setMembershipTable] = useState(cfg.membershipFallback || null);
  const [casualParkingTable, setCasualParkingTable] = useState(cfg.casualParkingFallback || null);
  const { enqueue } = useApiQueue();

  // 🔥 Effective total bays - second API se aayega
  const effectiveTotalBays = parkingBaysData?.total_bays ?? profileTable?.data?.total_bays?.value ?? '0';

  // ── Refs for latest state (Stale State Fix) ─────────────────────────────
  const profileRef        = useRef(null);
  const assetsRef         = useRef(null);
  const parkingRateRef    = useRef(null);
  const membershipRef     = useRef(null);
  const casualParkingRef  = useRef(null);

  // Sync refs with latest state
  useEffect(() => { profileRef.current       = profileTable;      }, [profileTable]);
  useEffect(() => { assetsRef.current        = assetsTable;       }, [assetsTable]);
  useEffect(() => { parkingRateRef.current   = parkingRateTable;  }, [parkingRateTable]);
  useEffect(() => { membershipRef.current    = membershipTable;   }, [membershipTable]);
  useEffect(() => { casualParkingRef.current = casualParkingTable;}, [casualParkingTable]);

  // ── Fetch BOTH APIs ─────────────────────────────────────────────────────────────
  useEffect(() => {
    if (hasFetchedRef.current) return;
    hasFetchedRef.current = true;
    fetchAllData();
  }, [year, month, monthNumber, contract]);

  const fetchAllData = async () => {
    try {
      // 🔥 Second API params based on page type
      const isOnStreet = cfg.pageType === 'on_street';
      const secondApiParams = isOnStreet ? {
        contract: "0030017",
        year: year,
        month: month,
        device_onstreet: "KFC",
        type: "on_street"
      } : {
        contract: "0030010",
        year: year,
        month: month,
        type: "off_street"
      };
      
      const [firstApiResponse, secondApiResponse] = await Promise.all([
        enqueue(() => apiCall('GET', '/boardpack/get-tables-data', { year, contract, month: monthNumber })),
        enqueue(() => apiCall('GET', '/boardpack/parking/bays', secondApiParams))
      ]);

      // Process first API response
      if (firstApiResponse?.success) {
        const data = firstApiResponse?.data || [];
        const find = (key, fb) => data.find(t => t.table_key === key) || fb;

        setProfileTable(find(cfg.profileKey, cfg.profileFallback));
        setAssetsTable(find(cfg.assetsKey, cfg.assetsFallback));
        if (cfg.parkingRateKey) setParkingRateTable(find(cfg.parkingRateKey, cfg.parkingRateFallback));
        if (cfg.membershipKey) setMembershipTable(find(cfg.membershipKey, cfg.membershipFallback));
        if (cfg.casualParkingKey) setCasualParkingTable(find(cfg.casualParkingKey, cfg.casualParkingFallback));
      }

      // 🔥 Process second API response for parking bays
      if (secondApiResponse?.success && secondApiResponse?.data) {
        setParkingBaysData(secondApiResponse.data);
      } else {
        console.warn("Second API failed:", secondApiResponse?.message);
        setParkingBaysData(null);
      }
      
    } catch (err) {
      console.error('Fetch error:', err);
    }
  };

  // ── Auto-save ──────────────────────────────────────────────────────
  const autoSave = () => {
    if (saveRef.current) clearTimeout(saveRef.current);
    saveRef.current = setTimeout(saveToAPI, API_CALL_TIME);
  };

  // ── Fixed saveToAPI using Refs ────────────────────────────────────────────
  const saveToAPI = async () => {
    try {
      setIsSaving(true);

      const tables = [
        { 
          table_key: profileRef.current?.table_key, 
          title: profileRef.current?.title, 
          data: profileRef.current?.data 
        },
        { 
          table_key: assetsRef.current?.table_key, 
          title: assetsRef.current?.title, 
          data: assetsRef.current?.data 
        },
      ];

      if (parkingRateRef.current) {
        tables.push({ 
          table_key: parkingRateRef.current.table_key, 
          title: parkingRateRef.current.title, 
          data: parkingRateRef.current.data 
        });
      }
      if (membershipRef.current) {
        tables.push({ 
          table_key: membershipRef.current.table_key, 
          title: membershipRef.current.title, 
          data: membershipRef.current.data 
        });
      }
      if (casualParkingRef.current) {
        tables.push({ 
          table_key: casualParkingRef.current.table_key, 
          title: casualParkingRef.current.title, 
          data: casualParkingRef.current.data 
        });
      }

      const res = await apiCall('POST', '/boardpack/add-tables-data', {
        contract, 
        year, 
        month: monthNumber, 
        created_by: 1, 
        tables,
      });

      if (!res?.success) throw new Error(res?.message || 'Save failed');
    } catch (err) {
      console.error('Save error:', err);
      toast.error('Failed to save changes');
    } finally {
      setIsSaving(false);
    }
  };
  
  // ── Patch helpers ──────────────────────────────────────────────────
  const patchProfile = (field, subField, value) => {
    setProfileTable(prev => ({
      ...prev,
      data: { ...prev.data, [field]: subField ? { ...prev.data[field], [subField]: value } : value },
    }));
    autoSave();
  };

  const handleParkingRateCell = (rIdx, key, value) => {
    setParkingRateTable(prev => ({
      ...prev,
      data: { ...prev.data, rows: prev.data.rows.map((r, i) => i === rIdx ? { ...r, [key]: value } : r) },
    }));
    autoSave();
  };

  const handleMembershipCell = (rIdx, key, value) => {
    setMembershipTable(prev => ({
      ...prev,
      data: { ...prev.data, rows: prev.data.rows.map((r, i) => i === rIdx ? { ...r, [key]: value } : r) },
    }));
    autoSave();
  };

  const handleCasualParkingCell = (rIdx, key, value) => {
    setCasualParkingTable(prev => ({
      ...prev,
      data: { ...prev.data, rows: prev.data.rows.map((r, i) => i === rIdx ? { ...r, [key]: value } : r) },
    }));
    autoSave();
  };

  const handleAssetSubCount = (flatIdx, value) => {
    const flat = groupsToFlat(assetsRef.current?.data?.groups || []).map((a, i) => i === flatIdx ? { ...a, subCount: value } : a);
    setAssetsTable(prev => ({ ...prev, data: { ...prev.data, groups: flatToGroups(flat) } }));
    autoSave();
  };

  const handleAssetTotalCount = (flatIdx, value) => {
    const flat = groupsToFlat(assetsRef.current?.data?.groups || []).map((a, i) => i === flatIdx ? { ...a, totalCount: value } : a);
    setAssetsTable(prev => ({ ...prev, data: { ...prev.data, groups: flatToGroups(flat) } }));
    autoSave();
  };

  // ── Derived ────────────────────────────────────────────────────────
  const pd = profileTable.data;
  const flatAssets = groupsToFlat(assetsTable.data.groups);
  const pageType = cfg.pageType;

  // ═══════════════════════════════════════════════════════════════════
  // RENDER
  // ═══════════════════════════════════════════════════════════════════
  return (
    <div className="min-h-screen p-8 bg-white">

      {/* ── Header ── */}
      <div className="flex justify-between items-center mb-3">
        <div className="ml-2">
          <img src={DammamContract} alt="Dammam Causeway Logo" style={{ height: '50px', objectFit: 'contain' }} />
        </div>
        <h1 className="text-xl font-bold flex-1 text-center">{profileTable.title}</h1>
        <div className="w-10 h-10 bg-[#003d7a] flex-shrink-0" />
      </div>

      {/* ══════════════════════════════════════
          ON-STREET PAGE
      ══════════════════════════════════════ */}
      {pageType === 'on_street' && (
        <div className="flex flex-row gap-0 !border-2 !border-black p-3">

          {/* ── LEFT ── */}
          <div className="flex-1 pr-4">

            {/* Activities icons row */}
            <div className="mb-4">
              <div className="text-[16px] font-semibold mb-4">Activities:</div>
              <div className="flex gap-0 justify-start ml-16 ">
                {['On Street', 'Car Park', 'Enforcement'].map(label => (
                  <div key={label} className="flex flex-col items-center gap-2 ">
                    {label === 'On Street' && <img src={OnStreet} alt="On Street" style={{ height: '150px', objectFit: 'contain' }} />}
                    {label === 'Car Park' && <img src={CarPark} alt="Car Park" style={{ height: '155px', objectFit: 'contain' }} />}
                    {label === 'Enforcement' && <img src={Enforcement} alt="Enforcement" style={{ height: '150px', objectFit: 'contain' }} />}
                  </div>
                ))}
              </div>
            </div>

            {/* Profile info */}
            <div className="flex flex-col gap-1 mb-4">

              {/* 🔥 READ-ONLY Total Bays */}
              <div className="flex items-center gap-2 ml-2 ">
                <div className="w-10 h-8 rounded flex items-center justify-center text-[8px] text-gray-400 mb-4">
                  <img src={OnStreet} alt="On Street" style={{ height: '50px', objectFit: 'contain' }} />
                </div>
                <span className="text-[12px]">
                  {pd.total_bays?.label}{' '}
                  <strong>
                    <input 
                      type="text" 
                      value={effectiveTotalBays}
                      readOnly 
                      disabled
                      className="font-bold outline-none bg-transparent !border-0 text-[12px] w-16 cursor-default" 
                    />
                  </strong>
                </span>
              </div>

              {/* Contract term - Editable */}
              <div className="flex items-center gap-2 ml-14">
                <div className="w-2 h-2 !border !border-blue-600 flex-shrink-0" />
                <span className="text-[12px] flex items-center gap-1 whitespace-nowrap">
                  Contract term{' '}
                  <strong><input type="text" value={pd.contract_term?.value || ''}
                    onChange={e => patchProfile('contract_term', 'value', e.target.value)}
                    className="font-bold outline-none bg-transparent !border-0 text-[12px] w-13" /></strong>; start date{' '}
                  <strong><input
                    type="text"
                    value={pd.contract_period?.start_date || ''}
                    onChange={e => patchProfile('contract_period', 'start_date', e.target.value)}
                    className="font-bold outline-none bg-transparent !border-0 text-[12px] w-17"
                  />
                    {' to '}
                    <input
                      type="text"
                      value={pd.contract_period?.end_date || ''}
                      onChange={e => patchProfile('contract_period', 'end_date', e.target.value)}
                      className="font-bold outline-none bg-transparent !border-0 text-[12px] w-20"
                    /></strong>
                </span>
              </div>

              {/* Rate per Hour - Editable */}
              <div className="flex items-center gap-2 ml-14">
                <div className="w-2 h-2 !border !border-blue-600 flex-shrink-0" />
                <span className="text-[12px] flex items-center gap-1">
                  Rate per Hour{' '}
                  <strong><input type="text" value={pd.rate_per_hour?.value || ''}
                    onChange={e => patchProfile('rate_per_hour', 'value', e.target.value)}
                    className="font-bold outline-none bg-transparent !border-0 text-[12px] w-52" /></strong>
                </span>
              </div>

              {/* Operation Timing - Editable */}
              <div className="flex items-center gap-2 ml-14">
                <div className="w-2 h-2 !border !border-blue-600 flex-shrink-0" />
                <span className="text-[12px] flex items-center gap-1">
                  Operation Timing –{' '}
                  <strong><input type="text" value={pd.operation_timing?.value || ''}
                    onChange={e => patchProfile('operation_timing', 'value', e.target.value)}
                    className="font-bold outline-none bg-transparent !border-0 text-[12px] w-24" /></strong>
                </span>
              </div>

              {/* Assets Deployed */}
              <div className="flex items-center gap-2 ml-14">
                <div className="w-3 h-3 rounded-full bg-red-500 flex-shrink-0" />
                <span className="text-[12px]">Assets Deployed</span>
              </div>
            </div>

            {/* Parking Rate Table - Editable */}
            {parkingRateTable && (
              <div className="ml-14">
                <table className="!border-collapse text-[9px]">
                  <thead>
                    <tr className="bg-gray-300">
                      <th className="!border !border-black px-4 py-2 font-bold text-center" style={{ minWidth: '200px' }}>
                        Dammam Causeway On Street
                      </th>
                      <th className="!border !border-black px-4 py-2 font-bold text-center" style={{ minWidth: '120px' }}>
                        Parking Rate
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {parkingRateTable.data.rows.map((row, rIdx) => (
                      <tr key={rIdx} className={rIdx % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                        <td className="!border !border-black px-3 py-1.5">
                          <input type="text" value={row.details || ''} onChange={e => handleParkingRateCell(rIdx, 'details', e.target.value)}
                            className="!border-0 bg-transparent outline-none text-[9px] w-full" />
                        </td>
                        <td className="!border !border-black px-3 py-1.5 text-center">
                          <input type="text" value={row.parking_rate || ''} onChange={e => handleParkingRateCell(rIdx, 'parking_rate', e.target.value)}
                            className="!border-0 bg-transparent outline-none text-[9px] text-end w-full" />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>

          {/* ── RIGHT — Assets ── */}
          <AssetsPanel
            assetsTable={assetsTable}
            flatAssets={flatAssets}
            onSubCount={handleAssetSubCount}
            onTotalCount={handleAssetTotalCount}
          />
        </div>
      )}

      {/* ══════════════════════════════════════
          OFF-STREET PAGE
      ══════════════════════════════════════ */}
      {pageType === 'off_street' && (
        <div className="flex flex-row gap-0 !border-2 !border-black p-3">

          {/* ── LEFT ── */}
          <div className="flex-1 pr-4">

            {/* Car Park icon + info */}
            <div className="flex items-start gap-3 mb-4">
              <div className="flex flex-col items-center w-20 flex-shrink-0 mb-4">
                <img src={CarPark} alt="Car Park" style={{ height: '50px', objectFit: 'contain' }} />
              </div>

              <div className="flex flex-col gap-1">

                {/* 🔥 READ-ONLY Total Bays */}
                <div className="flex items-center gap-2">
                  <span className="text-[12px]">
                    {pd.total_bays?.label}{' '}
                    <strong>
                      <input 
                        type="text" 
                        value={effectiveTotalBays}
                        readOnly 
                        disabled
                        className="font-bold outline-none bg-transparent !border-0 text-[12px] w-16 cursor-default" 
                      />
                    </strong>
                  </span>
                </div>

                {/* Contract term - Editable */}
                <div className="flex items-center gap-2 ml-4">
                  <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
                  <span className="text-[12px] flex items-center flex-wrap gap-1">
                    Contract term{' '}
                    <strong><input type="text" value={pd.contract_term?.value || ''}
                      onChange={e => patchProfile('contract_term', 'value', e.target.value)}
                      className="font-bold outline-none bg-transparent !border-0 text-[12px] w-11" /></strong>
                    ; start date{' '}
                    <strong><input type="text" value={pd.contract_period?.start_date || ''}
                      onChange={e => patchProfile('contract_period', 'start_date', e.target.value)}
                      className="font-bold outline-none bg-transparent !border-0 text-[12px] w-17" /></strong>
                    {' to '}
                    <strong><input type="text" value={pd.contract_period?.end_date || ''}
                      onChange={e => patchProfile('contract_period', 'end_date', e.target.value)}
                      className="font-bold outline-none bg-transparent !border-0 text-[12px] w-16" /></strong>
                  </span>
                </div>

                {/* Rate per Hour - Editable */}
                <div className="flex items-center gap-2 ml-4">
                  <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
                  <span className="text-[12px] flex items-center gap-1">
                    Rate per Hour{' '}
                    <strong><input type="text" value={pd.rate_per_hour?.value || ''}
                      onChange={e => patchProfile('rate_per_hour', 'value', e.target.value)}
                      className="font-bold outline-none bg-transparent !border-0 text-[12px] w-52" /></strong>
                  </span>
                </div>

                {/* Operation Timing - Editable */}
                <div className="flex items-center gap-2 ml-4">
                  <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
                  <span className="text-[12px] flex items-center gap-1">
                    Operation Timing –{' '}
                    <strong><input type="text" value={pd.operation_timing?.value || ''}
                      onChange={e => patchProfile('operation_timing', 'value', e.target.value)}
                      className="font-bold outline-none bg-transparent !border-0 text-[12px] w-24" /></strong>
                  </span>
                </div>

                {/* Assets Deployed */}
                <div className="flex items-center gap-2 ml-4">
                  <div className="w-3 h-3 rounded-full bg-red-500 flex-shrink-0" />
                  <span className="text-[12px]">Assets Deployed</span>
                </div>

                {/* Membership Rates note - Editable */}
                <div className="flex items-center gap-2 ml-4">
                  <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
                  <span className="text-[12px] whitespace-nowrap">
                    {(() => {
                      const fullText = pd.membership_tariff?.value || ''
                      const parts = fullText.split(' ')
                      const label = parts.slice(0, 2).join(' ')
                      const remaining = parts.slice(2).join(' ')
                      return (
                        <>
                          <span className="font-normal">{label} </span>
                          <input
                            type="text"
                            value={remaining}
                            onChange={e =>
                              patchProfile(
                                'membership_tariff',
                                'value',
                                label + ' ' + e.target.value
                              )
                            }
                            className="outline-none bg-transparent border-0 text-[12px] font-bold w-48 inline"
                          />
                        </>
                      )
                    })()}
                  </span>
                </div>
              </div>
            </div>

            {/* Tables row */}
            <div className="flex flex-col xl:flex-row gap-4 ml-4">

              {/* Membership Details Table - Editable */}
              <div className="flex flex-col gap-2 w-fit">
                {membershipTable && (
                  <table className="!border border-black border-collapse text-[9px] border-2 border-black">
                    <thead>
                      <tr className="bg-gray-300">
                        <th className="!border border-black px-2 py-1 text-center min-w-[200px]">
                          {membershipTable.title}
                        </th>
                        <th className="!border border-black px-2 py-1 text-center min-w-[70px]">
                          Location
                        </th>
                        <th className="!border border-black px-2 py-1 text-center min-w-[80px]">
                          Charges
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {membershipTable.data.rows.map((row, rIdx) => (
                        <tr key={rIdx}>
                          <td className="!border border-black px-1 py-1">
                            <input
                              value={row.membership_details || ''}
                              onChange={e => handleMembershipCell(rIdx, 'membership_details', e.target.value)}
                              className="w-full bg-transparent outline-none text-[9px]"
                            />
                          </td>
                          <td className="!border border-black px-1 py-1 text-center">
                            <input
                              value={row.location || ''}
                              onChange={e => handleMembershipCell(rIdx, 'location', e.target.value)}
                              className="w-full bg-transparent outline-none text-center text-[9px]"
                            />
                          </td>
                          <td className="!border border-black px-1 py-1 text-center">
                            <input
                              value={row.charges || ''}
                              onChange={e => handleMembershipCell(rIdx, 'charges', e.target.value)}
                              className="w-full bg-transparent outline-none text-center text-[9px]"
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}

                {/* Casual Parking Table - Editable */}
                {casualParkingTable && (
                  <table className="!border border-black border-collapse text-[9px] border-2 border-black">
                    <thead>
                      <tr className="bg-gray-300">
                        <th className="!border border-black px-2 py-1 text-center min-w-[120px]">
                          {casualParkingTable.title}
                        </th>
                        <th className="border border-black px-2 py-1 text-center min-w-[110px]">
                          Parking Rate
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {casualParkingTable.data.rows.map((row, rIdx) => (
                        <tr key={rIdx}>
                          <td className="!border border-black px-1 py-1">
                            <input
                              value={row.details || ''}
                              onChange={e => handleCasualParkingCell(rIdx, 'details', e.target.value)}
                              className="w-full bg-transparent outline-none text-[9px]"
                            />
                          </td>
                          <td className="!border border-black px-1 py-1 text-center">
                            <input
                              value={row.parking_rate || ''}
                              onChange={e => handleCasualParkingCell(rIdx, 'parking_rate', e.target.value)}
                              className="w-full bg-transparent outline-none text-center text-[9px]"
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                </table>
                )}
              </div>
            </div>
          </div>

          {/* ── RIGHT — Assets ── */}
          <AssetsPanel
            assetsTable={assetsTable}
            flatAssets={flatAssets}
            onSubCount={handleAssetSubCount}
            onTotalCount={handleAssetTotalCount}
          />
        </div>
      )}
    </div>
  );
};

export default DammamCausewayProfile;